import { render, staticRenderFns } from "./SpecializationSettings.vue?vue&type=template&id=40baf534&scoped=true"
import script from "./SpecializationSettings.vue?vue&type=script&lang=js"
export * from "./SpecializationSettings.vue?vue&type=script&lang=js"
import style0 from "./SpecializationSettings.vue?vue&type=style&index=0&id=40baf534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40baf534",
  null
  
)

export default component.exports